import TitleMediaContainer from './TitleMediaContainer';

export default TitleMediaContainer;
